import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Form, InputGroup } from "react-bootstrap";
import { IoIosSearch } from "react-icons/io";
import { useNavigate } from "react-router-dom";

import "../../../../SignUp/onBoarding/personality.css";

import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";
import { useAlert } from "../../../../../Context/AlertModalContext";
import { useProfile } from "../../../../userflow/components/context/ProfileContext";
import { showAlert } from "../../../../../utils/alertUtils";
import {
  getPersonalityOptions,
  getSelectedPersonalities,
  updatePersonalities,
} from "../../../../../actions/user";

export default function PersonalityProfile() {
  const { updateProfile } = useProfile();
  const [searchTerm, setSearchTerm] = useState("");
  const personalityListEndRef = useRef(null);
  const [hasAddedPersonality, setHasAddedPersonality] = useState(false);
  const [personalities, setPersonalities] = useState([]);
  const { getCookie } = useCookies();
  const alert = useAlert();
  const [selectedPersonalities, setSelectedPersonalities] = useState([]);
  const navigate = useNavigate();
  const approvalstatus = getCookie("approval");

  const filteredPersonality = personalities.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    // Fetch personality options
    const fetchPersonalityOptions = async () => {
      try {
        const data = await getPersonalityOptions();
        if (data.personalities) {
          setPersonalities(data.personalities);
        }
      } catch (error) {
        console.error("Error fetching personality options:", error);
      }
    };

    fetchPersonalityOptions();
  }, []);

  useEffect(() => {
    // Fetch selected personalities
    const fetchSelectedPersonalities = async () => {
      try {
        const data = await getSelectedPersonalities();
        if (data.personalities) {
          setSelectedPersonalities(data.personalities);
        }
      } catch (error) {
        console.error("Error fetching selected personalities:", error);
      }
    };

    fetchSelectedPersonalities();
  }, [personalities]);

  useEffect(() => {
    if (hasAddedPersonality && personalityListEndRef.current) {
      personalityListEndRef.current.scrollIntoView({ behavior: "smooth" });
      setHasAddedPersonality(false);
    }
  }, [hasAddedPersonality]);

  async function savePersonalities() {
    if (
      selectedPersonalities?.length < 3 ||
      selectedPersonalities?.length > 8
    ) {
      // Handle the case where there are fewer than 2 personalities selected
      alert.setModal({
        show: true,
        title: "Update Personalities",
        message:
          "Please select between 3 and 8 personalities. Selections below 3 or above 8 are not allowed.",
      });
      return;
    }

    try {
      await updatePersonalities(selectedPersonalities);
      await updateProfile("update");

      if (approvalstatus === "PENDING") {
        showAlert(
          "Success",
          "Approval request sent!",
          () => (window.location.href = "/user/home")
        );
      } else {
        showAlert(
          "Success",
          "Successfully updated",
          () => (window.location.href = "/user/home")
        );
      }
    } catch (error) {
      console.error("Error updating personalities:", error);
    }
  }

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
          overflow: "hidden",
          padding: "2rem",
        }}
      >
        <Container className="personality-main" style={{ overflow: "hidden" }}>
          <Container className="personality-content">
            <Container className="personality-details">
              <div className="personality-section">
                <Container className="personality-text">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="20" cy="20" r="18" fill="#4E1173" />
                    <path
                      d="M17.3634 17.0516C17.328 16.3153 17.5856 15.5949 18.0798 15.0479C18.574 14.501 19.2647 14.172 20.0009 14.1328C20.737 14.172 21.4277 14.501 21.922 15.0479C22.4162 15.5949 22.6738 16.3153 22.6384 17.0516C22.6726 17.787 22.4144 18.506 21.9202 19.0517C21.4261 19.5974 20.7361 19.9254 20.0009 19.9641C19.2657 19.9254 18.5757 19.5974 18.0815 19.0517C17.5874 18.506 17.3292 17.787 17.3634 17.0516ZM28.7759 20.0016C28.7785 21.7436 28.2582 23.4462 27.2821 24.8891C27.2566 24.9332 27.2273 24.975 27.1946 25.0141C26.3882 26.1753 25.3127 27.124 24.06 27.7792C22.8073 28.4344 21.4146 28.7766 20.0009 28.7766C18.5872 28.7766 17.1945 28.4344 15.9417 27.7792C14.689 27.124 13.6135 26.1753 12.8071 25.0141C12.7745 24.975 12.7452 24.9332 12.7196 24.8891C11.9556 23.751 11.4688 22.4497 11.2985 21.0895C11.1281 19.7294 11.2789 18.3482 11.7386 17.0569C12.1984 15.7655 12.9544 14.5998 13.946 13.6533C14.9376 12.7069 16.1371 12.0059 17.4485 11.6068C18.7599 11.2076 20.1466 11.1213 21.4973 11.3547C22.8481 11.5882 24.1253 12.135 25.2266 12.9511C26.3279 13.7673 27.2226 14.8302 27.839 16.0546C28.4554 17.279 28.7762 18.6308 28.7759 20.0016ZM12.1634 20.0016C12.161 21.3332 12.4988 22.6433 13.1446 23.8078C14.5009 22.0266 17.1009 20.9141 20.0009 20.9141C22.9009 20.9141 25.5009 22.0266 26.8571 23.8078C27.4379 22.7614 27.7714 21.5959 27.8321 20.4007C27.8927 19.2054 27.6789 18.0121 27.207 16.9123C26.7351 15.8125 26.0176 14.8353 25.1096 14.0557C24.2016 13.2761 23.1271 12.7147 21.9686 12.4146C20.81 12.1145 19.5981 12.0836 18.4258 12.3243C17.2535 12.5651 16.1518 13.071 15.2053 13.8034C14.2588 14.5358 13.4925 15.4752 12.9652 16.5496C12.438 17.624 12.1637 18.8048 12.1634 20.0016Z"
                      fill="white"
                    />
                  </svg>
                  <p>How would you describe your personality?</p>
                </Container>
                <InputGroup
                  className="personality-search-bar"
                  style={{ overflow: "hidden" }}
                >
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    style={{ border: "none", outline: "none", height: "100%" }}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <InputGroup.Text
                    className="search-icon"
                    style={{ position: "relative", top: "0rem" }}
                  >
                    <IoIosSearch />
                  </InputGroup.Text>
                </InputGroup>
                <div>
                  {selectedPersonalities?.length < 3 ||
                  selectedPersonalities?.length > 8 ? (
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#4E1173",
                        lineHeight: "18.5%",
                        marginBottom: "20px",
                      }}
                    >
                      Select 3-8 options
                    </p>
                  ) : null}
                </div>
                <div
                  className="personality-types"
                  style={{ maxHeight: "50vh", overflow: "auto" }}
                >
                  <div
                    className="personality-selected"
                    style={{
                      marginTop: "12px",
                      marginBottom: "10px",
                      marginRight: "10px",
                    }}
                  >
                    {selectedPersonalities.map((personality, index) => (
                      <div
                        key={index}
                        className="personality-item-select"
                        style={{
                          backgroundColor: selectedPersonalities.find(
                            (p) => p.name === personality.name
                          )
                            ? "rgb(179 73 245)"
                            : "transparent",
                          color: "#fff",
                          padding: "10px",
                          marginRight: "3px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>{personality.name}</span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPersonalities(
                              selectedPersonalities.filter(
                                (p) => p !== personality
                              )
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#fff",
                            backgroundColor: "gray",
                            borderRadius: "50%",
                            padding: "0 5px",
                            marginTop: "-50px",
                            marginRight: "-15px",
                          }}
                        >
                          ✖
                        </span>
                      </div>
                    ))}
                  </div>
                  <div
                    className="personality-options-grid"
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    {filteredPersonality.map((personality, index) => (
                      <div
                        key={index}
                        className="personality-item"
                        onClick={() => {
                          if (
                            selectedPersonalities.find(
                              (p) => p.name === personality.name
                            )
                          ) {
                            setSelectedPersonalities(
                              selectedPersonalities.filter(
                                (p) => p.name !== personality.name
                              )
                            );
                          } else {
                            setSelectedPersonalities([
                              ...selectedPersonalities,
                              personality,
                            ]);
                          }
                        }}
                        style={{
                          backgroundColor: selectedPersonalities.find(
                            (p) => p.name === personality.name
                          )
                            ? "#F7ECFF"
                            : "transparent",
                        }}
                      >
                        {personality.name}
                      </div>
                    ))}
                    <div ref={personalityListEndRef} />
                  </div>
                </div>
              </div>
            </Container>
            <div
              className="d-flex justify-content-center"
              style={{
                position: "fixed",
                bottom: "30px",
                width: "100%",
                gap: "30px",
              }}
            >
              <button
                className="global-cancel-button"
                onClick={() => navigate("/updateprofile")}
              >
                Cancel
              </button>
              <button
                onClick={savePersonalities}
                type="submit"
                className="global-save-button"
              >
                Save
              </button>
            </div>
          </Container>
        </Container>
      </div>
    </Sidebar>
  );
}
